var icons = {"icon":"_icon_ki8xy_7"};

export { icons as default };
